import { t } from '@lingui/macro'
import { SurveyCreateDTO, SurveyLanguage } from '@om1/joint-insights-api'
import { SurveyService } from '@om1/joint-insights-api/codegen/client/services/SurveyService'
import { notificationActions } from '@om1/platform-notifications'
import { call, put, select } from 'redux-saga/effects'
import { JointInsightsState } from '../joint-insights-state'
import { SurveyState } from '../state/survey-reducer'

// Saga worker
export function createSubmitSurveySaga() {
    return function* () {
        const surveyState = yield select((state: JointInsightsState) => state.survey)
        const language = yield select((state: JointInsightsState) => state.language.locale)
        try {
            yield call(SurveyService.submitSurveyResultSurveyPost, { requestBody: mapStateToDto(surveyState, language) })
        } catch (error) {
            console.log(error)
            yield put(notificationActions.error(t`Error submitting survey`, { persist: true }))
        }
    }
}

const mapStateToDto = (state: SurveyState, language: SurveyLanguage): SurveyCreateDTO => {
    return {
        patient_info: {
            age: state.patientInfo.age!,
            last_name: state.patientInfo.lastName,
            first_name: state.patientInfo.firstName,
            dob: state.patientInfo.dob,
            mrn: state.patientInfo.mrn,
            phone: state.patientInfo.phone,
            sex: state.patientInfo.sex!
        },
        survey_results: {
            quiz_answers: state.quizAnswers,
            preferences: state.preferences,
            reviews: state.reviews
        },
        language: language
    }
}
